import firebase from 'firebase';

var config = {
apiKey: process.env.REACT_APP_FIREBASE_API,
authDomain: process.env.REACT_APP_AUTH_DOMAIN,
databaseURL: "https://arielle-berman-newsletter.firebaseio.com",
projectId: "arielle-berman-newsletter",
storageBucket: "arielle-berman-newsletter.appspot.com",
messagingSenderId: "20087177367"
};

let fireBaseConfig = firebase.initializeApp(config);

export default fireBaseConfig;


// WEBPACK FOOTER //
// ./src/Firebase.js